'use strict';

var _ = require('lodash');
var ThematicBarChartDirective = function ThematicBarChartDirective(Chart, dataProviderService) {
  return {
    restrict: 'E',
    template: require('../templates/thematic-bar-chart.html'),
    controller: 'ThematicBarChartController',
    scope: {
      defaultMode: '=',
      screenState: '=',
      screen: '@',
      brushFilterType: '@',
      type: '@',
      label: '@',
      preLabel: '@',
      isModeVisible: '=',
      postDepartureModeName: '=?',
      listenedBrushNames: '=?',
      doNotResetOnLink: '=?'
    },
    link: function link(scope, element) {
      var chartElement = element.find('.chart-container');
      var chart = new Chart(chartElement, scope.chartFormatters);
      if (!scope.doNotResetOnLink) {
        scope.resetChart();
      }
      scope.renderChartDataPresent = function (data) {
        var metric = dataProviderService.getSelectedMetric(scope.screen, scope.mode);
        chart.withMetric(metric).render(data);
        scope.$emit('reload-carousel');
      };
      scope.restoreSelection = function (ranges) {
        scope.ranges = ranges;
        chart.setInitialSelection(ranges);
      };
      scope.setInitialSelection = function (silent) {
        var range = scope.getDefaultSelection();
        scope.ranges = [range];
        chart.setInitialSelection(range, silent);
      };
      scope.isNoBarSelected = function () {
        return _.chain(chartElement.find('.group-data').find('.groups').find('.stack')).map('classList').filter(function (list) {
          return _.includes(list, 'selected');
        }).isEmpty().value();
      };

      // reset chart with the new data
      scope.$on('search-criteria:searchChangeEvent', function () {
        scope.removeData();
        scope.resetChart();
      });

      // update the main chart based on the thematic chart selection
      chart.on('rangechangeend', function (brushRanges, silent) {
        scope.ranges = brushRanges;
        scope.handleBrushEnd(silent);
      });
      scope.$on(scope.screen + '-' + scope.mode + '-' + scope.type + ':resetWithDataRetriever', function (event, dataRetriever) {
        if (dataRetriever) {
          scope.resetChart();
        }
      });
      scope.$on(scope.screen + ':scenariosChanged', function () {
        scope.redrawChartWithNewFilter();
      });
      scope.$watch('isModeVisible', function (newValue, oldValue) {
        if (newValue === true && oldValue === false && scope.isNoBarSelected()) {
          scope.resetChart();
        }
      });
      scope.$watch('screenState.dataRepresentation', function (dataRepresentation) {
        if (dataRepresentation) {
          scope.onDataRepresentationChange(dataRepresentation);
        }
      });

      //send with id
      scope.$emit('chart:init', scope.screen + '-' + scope.mode + '-' + scope.type);
      scope.$watchGroup(['screenState.isFlightAnalysisGridExpanded', 'screenState.isMarketAnalysisGridExpanded', 'screenState.isMarketProductGridExpanded', 'screenState.isServiceGridExpanded'], function (currentExpansionState, prevExpansionState) {
        scope.reloadChartsDuringMaximize(currentExpansionState, prevExpansionState, chart.getSelection());
      });
    }
  };
};
ThematicBarChartDirective.$inject = ['ThematicBarChart', 'ThematicBarChartDataProviderService'];
module.exports = ThematicBarChartDirective;